import React, { useEffect } from "react";
import useState from "react-usestateref";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import Footer from "../../../GlobalComponents/Footer";
import Navbar from "../Navbar";
// import dateFormat from "dateformat";
import { bookingService,reportEquipmentUsedBookingService,kitService,surgeonService,operationService} from "../../../../services";
import InfinitScroll from "react-infinite-scroll-component";
// import moment from "moment";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import * as excelJs from "exceljs";
import FilterTooltip from "./Modal/Filter";
import Sidebar from "./Sidebar";
import { getStatusConfig } from "../../../../helpers/statusHelper";

const Index = () => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
    const [search, setSearch] = useState("");
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(6);
    const [bookingList, setBokingList] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const [isLoading, setIsLoading] = useState(false);
    const [totalItemsCount, setTotalItemsCount,totalItemsCountRef] = useState(0);
    const [hospitals,setHospitalList] = useState([]);
    const [hospitalId,setHospitalId,hospitalIdRef] = useState("");

    const [selectedHospital,setSelectedHospital] = useState([{label:"All Hospital",value:""}]);

    const [repsUsers,setRepsUserList] = useState([]);
    const [repsUserId,setRepsUserId,repsUserIdRef] = useState("");
    const [selectedRepsUser,setSelectedRepsUser] = useState([{label:"All Reps",value:""}]);

    const [filterModal, setFilterModal] = useState(false);
    const [filterPoChase, setFilterPoChase,filterPoChaseRef] = useState("all");
    const [filterCreateDate, setFilterCreateDate,filterCreateDateRef] = useState("");
    const [kits,setKits] = useState([]);
    const [selectedKit,setSelectedKit] = useState([]);
    const [selectdKitValue,setSelectdKitValue,selectdKitValueRef]=useState("");
    const [surgeons,setSurgeons] = useState([]);
    const [selectedSurgeon,setSelectedSurgeon] = useState([{label:"All Surgeon",value:""}]);
    const [surgeonId,setSurgeonId,surgeonIdRef]=useState("");
    const [operationsList,setOperationsList] = useState([]);
    const [selectedOperation,setSelectedOperation] = useState([{label:"All Operation",value:""}]);
    const [operationId,setOperationId,operationIdRef]=useState("");
    const [selectdSetValue,setSelectdSetValue,selectdSetValueRef]=useState("");
    const [sideBarFilterOperationToDate,setSideBarFilterOperationToDate,sideBarFilterOperationToDateRef]=useState(new Date());
    const [sideBarFilterOperationFromDate,setSideBarFilterOperationFromDate,sideBarFilterOperationFromDateRef]=useState(new Date());
    const [sideBarFilterDispatchedToDate,setSideBarFilterDispatchedToDate,sideBarFilterDispatchedToDateRef]=useState("");
    const [sideBarFilterDispatchedFromDate,setSideBarFilterDispatchedFromDate,sideBarFilterDispatchedFromDateRef]=useState("");

    const [selectedBookingType, setSelectedBookingType] = useState([{ value: ["consignment", "loan"], label: "All" }]);
    const [bookingType, setBookingType,bookingTypeRef] = useState(["consignment", "loan"]);

    const getList = async (flag, searchTerm) => {
        setLoading(true);
        setActivePage(flag ? 1 : activePage + 1);
        try {
            const res = await reportEquipmentUsedBookingService.getReport({
                working_delivery_from_date: "",
                type: bookingTypeRef.current,
                status: ["booked", "dispatch", "return", "close", "cancle","prepare","query"],
                operation_from_date: sideBarFilterOperationFromDateRef.current,
                operation_to_date: sideBarFilterOperationToDateRef.current,
                dispatch_from_date: sideBarFilterDispatchedFromDateRef.current,
                dispatch_to_date: sideBarFilterDispatchedToDateRef.current,
                search: searchTerm != undefined ? searchTerm : search,
                page: flag ? 1 : activePage + 1,
                limit: limit,
                hospitalFilter:hospitalIdRef.current,
                repsUserFilter:repsUserIdRef.current,
                kitFilter:selectdKitValueRef.current,
                surgeonFilter:surgeonIdRef.current,
                operationFilter:operationIdRef.current,
                setFilter:selectdSetValueRef.current,
                po_check: filterPoChaseRef.current,
                created_date: filterCreateDateRef.current,
            });
            let bookingRes = flag ? res.data : bookingList.concat(res.data);
            setBokingList(bookingRes);
            setTotalItemsCount(res?.total_count);
            setLoading(false);
        } catch (error) {
            console.error("Error: ", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getHospitalList();
        getRepsUserList();
        getKitListDropdown();
        getSurgeonListDropdown();
        getOperationListDropdown();
        console.log(setLimit,selectedBookingType,totalItemsCount,hospitalId,repsUserId,selectdKitValue,bookingType,
            surgeonId,operationId,selectdSetValue,filterPoChase,filterCreateDate,sideBarFilterOperationToDate,sideBarFilterOperationFromDate,sideBarFilterDispatchedToDate,sideBarFilterDispatchedFromDate);
        setUser(JSON.parse(localStorage.getItem("user")));
        setSearch("");
    }, []);

    useEffect(() => {
        getList(1);
    }, [filterCreateDateRef.current,filterPoChaseRef.current,selectdKitValueRef.current,
        surgeonIdRef.current,operationIdRef.current,selectdSetValueRef.current,selectedBookingType,hospitalIdRef.current,repsUserIdRef.current,sideBarFilterOperationToDateRef.current,sideBarFilterOperationFromDateRef.current,sideBarFilterDispatchedToDateRef.current,sideBarFilterDispatchedFromDateRef.current,bookingTypeRef.current]);

    const getXlsxData = async () => {
        setIsLoading(true);
        try {
            const filterData = {
                working_delivery_from_date: "",
                type: bookingTypeRef.current,
                status: ["booked", "dispatch", "return", "close", "cancle","prepare","query"],
                operation_from_date: sideBarFilterOperationFromDateRef.current,
                operation_to_date: sideBarFilterOperationToDateRef.current,
                dispatch_from_date: sideBarFilterDispatchedFromDateRef.current,
                dispatch_to_date: sideBarFilterDispatchedToDateRef.current,
                search: search,
                // page: 1,
                // limit: totalItemsCountRef.current,
                hospitalFilter:hospitalIdRef.current,
                repsUserFilter:repsUserIdRef.current,
                kitFilter:selectdKitValueRef.current,
                surgeonFilter:surgeonIdRef.current,
                operationFilter:operationIdRef.current,
                setFilter:selectdSetValueRef.current,
                po_check: filterPoChaseRef.current,
                created_date: filterCreateDateRef.current,
            };
            console.log(totalItemsCountRef.current);
            let skip = 0;
            let allData = [];
            let hasMore = true;

            while (hasMore) {
                const res = await  reportEquipmentUsedBookingService.getReportExport(filterData, skip);

                if (!res.status) {
                    hasMore = false;
                    break;
                }

                allData.push(...res.data);

                hasMore = res.hasMore;

                skip += 2000;
            }

            handleExportClick(allData);
        } catch (error) {
            setIsLoading(false);
            console.error("Error: ", error);
        }
    };

    const addNewlines = (string, interval) => {
        let result = "";
        for (let i = 0; i < string.length; i++) {
          if (i > 0 && i % interval === 0) {
            result += "\n";
          }
          result += string[i];
        }
        return result;
    };

    const handleExportClick = async (data) => {
        const workbook = new excelJs.Workbook();
        const ws = workbook.addWorksheet("Dispatch Worksheet");
        
        const header1 = [
            "Booking Id",
            "Hospital Name",
            "Surgeon Name",
            "Operation",
            "Reps Name",
            "Kit Used",
            "Manufacturers Product Code",
            "Feedback Notes",
            "Outcome of the case"
        ];

        const header1Row = ws.addRow(header1);
        header1Row.eachCell((cell) => {
            cell.font = {
                bold: true,
                size: 11,
            };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "CCC0DA" }
            };
            cell.border = {
                top: {style:"thin"},
                left: {style:"thin"},
                bottom: {style:"thin"},
                right: {style:"thin"}
            };
        });
    
        if (data?.length) {
            // let kitset = "";
            // let kitName = "";
            // let returnDate = "";
            
            data && data.map(item => {
               
                let surgeonName = item?.bookingSurgeonData?.SurgeonDetail?.[0];
                let repsName = item?.assignedRepsDetail?.[0];
                let operationName = item.operation_name === "Other" ? item.other_opration : item.operation_name;
                
                  const productDetails = (item?.itemUsedProducts || []).reduce(
                    (acc, p) => {
                      const name = p?.productData?.name;
                      const code = p?.productData?.manufacturers_product_code;
                  
                      // remove Space_Holder
                      if (name && name !== "Space_Holder") acc.names.push(name);
                      if (code && code !== "Space_Holder") acc.codes.push(code);
                  
                      return acc;
                    },
                    { names: [], codes: [] }
                  );
                  
                  //  clean output
                  const kitUsed = productDetails.names.length
                    ? productDetails.names.join("\n")
                    : "-";
                  
                  const manufactureCode = productDetails.codes.length
                    ? productDetails.codes.join("\n")
                    : "-";
                const description = item?.bookingProductsReviews?.[0]?.description;

                let feedbackNote = description
                ? (description.length > 40 ? addNewlines(description, 40) : description)
                : "-";

                const rowData = [
                    item?.booking_id || "",
                    item?.hospitalData?.[0]?.name || "",  
                    surgeonName ? `${surgeonName.first_name} ${surgeonName.last_name}` : "",
                    operationName,
                    repsName ? `${repsName.first_name} ${repsName.last_name}` : "",
                    kitUsed,
                    manufactureCode,
                    feedbackNote,
                    item?.bookingProductsReviews?.[0]?.review || "",
                    // kitName,
                    // kitset,
                    // returnDate,
                    // moment(item?.delivery_date).format("ddd, MMMM Do, YYYY"),
                    // item?.delivery_date_slot, 
                    // moment(item?.operation_date).format("ddd, MMMM Do, YYYY"),
                    // item?.operation_date_slot,
                    // item?.dispatchData?.length
                    // ? moment(item.dispatchData[0].createdAt).format("ddd, MMMM Do, YYYY")
                    // : "-", 
                    // item?.bookingLogs[0]?.bookingLogs_by_user[0]?.first_name+" "+item?.bookingLogs[0]?.bookingLogs_by_user[0]?.last_name,
                    // item?.dispatchData[0]?.dispatched_by,
                    // PrepareTimer(item),
                    // notesLines,
                ];
                let row = ws.addRow(rowData);
                
                const countLines = (text) =>
                    text ? text.toString().split("\n").length : 1;

                const maxLines = Math.max(
                    countLines(kitUsed),
                    countLines(manufactureCode),
                    countLines(feedbackNote)
                );

                row.height = maxLines * 18; // 🔥 perfect spacing
                row.eachCell((cell) => {
                    cell.alignment = {
                        vertical: "top",
                        horizontal: "left",
                        wrapText: true
                    };
                });

                // row.height = item?.bookingKitSetId?.length ? item.bookingKitSetId.length * 12 : 15;
                // ws.getCell("C"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
                // ws.getCell("D"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
                // ws.getCell("J"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
                // // ws.getCell("E"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
                // ws.getCell(`E${row.number}`).alignment = { vertical: "bottom", horizontal: "left", wrapText: true};
                // ws.getCell(`F${row.number}`).alignment = { vertical: "bottom", horizontal: "left", wrapText: true};
            });
        }

        // Iterate through each column to calculate and set width
        ws.columns.forEach((column, columnIndex) => {
            let maxLength = 0;
        
            for (let rowIndex = 3; rowIndex <= ws.rowCount; rowIndex++) {
                const cellValue = ws.getCell(rowIndex, columnIndex + 1).value;
        
                const value = cellValue ? cellValue.toString() : "";
                const cleanValue = value.replace(/\n/g, " ");
        
                if (cleanValue.length > maxLength) {
                    maxLength = cleanValue.length;
                }
            }
        
            // 🔥 FIXED WIDTH FOR THESE COLUMNS
            if (columnIndex + 1 === 6 || columnIndex + 1 === 7) {
                column.width = 50;
            } else {
                column.width = maxLength < 25 ? 25 : maxLength + 5;
            }
        });


        ws.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
                row.eachCell((cell) => {
                    cell.border = {
                        top: { style: "thin", color: { argb: "000000" } },
                        left: { style: "thin", color: { argb: "000000" } },
                        bottom: { style: "thin", color: { argb: "000000" } },
                        right: { style: "thin", color: { argb: "000000" } },
                    };
                });
            }
        });

        const excelBlob = await workbook.xlsx.writeBuffer();
        const excelUrl = URL.createObjectURL(
            new Blob([excelBlob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
        );
        setIsLoading(false);
        const link = document.createElement("a");
        link.href = excelUrl;
        link.download = "Equipment-Used-reports";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(excelUrl);
        document.body.removeChild(link);  
    };

    const getHospitalList = async () => {
        try {
            
            const res = await bookingService.getHospitalsList({
                search: ""
            });
            
            if(res.status === 200){
                showHospitalsList(res?.data);
            }
            
        } catch (error) {
            console.error("Error: ", error);
        }
    };
    


    const showHospitalsList = (hospitalsList) => {
        let tempHospitals = [{label:"All Hospital",value:""}];
        hospitalsList.map((item)=> {
            let option = {value: item._id, label: item.name};
            tempHospitals.push(option);
        });
        setHospitalList(tempHospitals);
    };

    const getRepsUserList = async () => {
        try {
            
            const res = await bookingService.getRepsUsersList({
                search: ""
            });

            if(res.status === 200){
                showRepsUsersList(res?.data);
            }
            
        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const showRepsUsersList = (repsUsersList) => {
        let tempRepsUsers = [{label:"All Reps",value:""}];
        repsUsersList.map((item)=> {
            let option = {
                value: item._id, 
                // label: item.name
                label: `${item.first_name} ${item.last_name}` 
            };
            tempRepsUsers.push(option);
        });
        setRepsUserList(tempRepsUsers);
    };

    const getKitListDropdown = async() => {
        try {

            const res = await kitService.kitListDropdown({search:""});

            let kitList = res?.data ? res?.data : [];
            let tempKitList = [];

            kitList?.length && kitList.map((item)=> {
                var option = {value: item._id, label: item.name};
                tempKitList.push(option);
            });

            setKits(tempKitList); 

        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const getSurgeonListDropdown = async() => {
        try {

            const res = await surgeonService.getSurgeonsList({search:""});
            
            let surgeonList = res?.data ? res?.data : [];
            let tempSurgeonList = [{label:"All Surgeon",value:""}];
            surgeonList && surgeonList.map(item => {
                let option = {
                    value: item._id,
                    label: item.first_name + " " + item.last_name,
                    notes:item?.notes ? item?.notes : ""
                };
                tempSurgeonList.push(option);
            });
            setSurgeons(tempSurgeonList); 

        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const getOperationListDropdown = async() => {
        try {

            const res = await operationService.getOperationsList({search:""});
            
            let operationList = res?.data ? res?.data : [];
            let tempOperationList = [{label:"All Operation",value:""}];
            operationList && operationList.map(item => {
                let option = { value: item.name, label: item.name,id:item._id };
                tempOperationList.push(option);
            });
            setOperationsList(tempOperationList); 

        } catch (error) {
            console.error("Error: ", error);
        }
    };

    if (!user || user.data.user_role !== "admin") {
        return <Redirect to="/" />;
    }

    const handleFilterToggle = () => {
        setFilterModal(!filterModal);
    };

    const handleFilterRefreesh = (data) => {
        if(data !== undefined){
            setBokingList([]);
            if(filterPoChaseRef.current === data?.filterPoChase && filterCreateDateRef.current === data?.filterCreateDate && 
                selectdKitValueRef.current === data?.selectdKitValue && 
                surgeonIdRef.current === data?.surgeonId &&
                operationIdRef.current === data?.operationId &&
                selectdSetValueRef.current === data?.selectdSetValue &&
                sideBarFilterOperationToDateRef.current === data?.sideBarFilterOperationToDate &&
                sideBarFilterOperationFromDateRef.current === data?.sideBarFilterOperationFromDate &&
                sideBarFilterDispatchedToDateRef.current === data?.sideBarFilterDispatchedToDate &&
                sideBarFilterDispatchedFromDateRef.current === data?.sideBarFilterDispatchedFromDate &&
                hospitalIdRef.current === data?.hospitalId &&
                repsUserIdRef.current === data?.repsUserId &&
                bookingTypeRef.current === data?.bookingType){
                getList(1);
            }
            
            setActivePage(1);
            // setFilterModal(!filterModal);
            setFilterPoChase(data?.filterPoChase);
            setFilterCreateDate(data?.filterCreateDate);
            setSelectdKitValue(data?.selectdKitValue);
            setSelectedKit(data?.selectedKitProp);
            setSurgeonId(data?.surgeonId);
            setSelectedSurgeon(data?.selectedSurgeonProp);
            setOperationId(data?.operationId);
            setSelectedOperation(data?.selectedOperationProp);
            setSelectdSetValue(data?.selectdSetValue);
            setSideBarFilterOperationToDate(data?.sideBarFilterOperationToDate);
            setSideBarFilterOperationFromDate(data?.sideBarFilterOperationFromDate);
            setSideBarFilterDispatchedToDate(data?.sideBarFilterDispatchedToDate);
            setSideBarFilterDispatchedFromDate(data?.sideBarFilterDispatchedFromDate);
            setHospitalId(data?.hospitalId);
            setSelectedHospital(data?.selectedHospitalProp);
            setRepsUserId(data?.repsUserId);
            setSelectedRepsUser(data?.selectedRepsUserProp);
            setSelectedBookingType(data?.selectedBookingTypeProp);
            setBookingType(data?.bookingType);
        }
    };




    return (
        <div>
            <Navbar activePage="reports" />
            <div className="container-fluid">

                <div className="row pt-4">
                    <div className="col-lg-2 side-filters side-reports">
                    <div className="card side-report">
                        <Sidebar
                            activePage="report-equipment-used-booking"
                            dispatchCount={totalItemsCount}
                            filterPoChase={filterPoChaseRef.current}
                            filterCreateDate={filterCreateDateRef.current}
                            handleFilterRefreesh={(data)=>handleFilterRefreesh(data)}
                            kits={kits}
                            selectedKitProp={selectedKit}
                            surgeons={surgeons}
                            selectedSurgeonProp={selectedSurgeon}
                            operationsList={operationsList}
                            selectedOperationProp={selectedOperation}
                            selectedFilterOperationToDate={sideBarFilterOperationToDateRef.current}
                            selectedFilterOperationFromDate={sideBarFilterOperationFromDateRef.current}
                            selectedFilterDispatchedToDate={sideBarFilterDispatchedToDateRef.current}
                            selectedFilterDispatchedFromDate={sideBarFilterDispatchedFromDateRef.current}
                            hospitals={hospitals}
                            selectedHospitalProp={selectedHospital}
                            repsUsers={repsUsers}
                            selectedRepsUserProp={selectedRepsUser}
                            bookingType = {bookingTypeRef.current}
                            selectedBookingTypeProp = {selectedBookingType}
                        />  
                    </div>
                       

                    </div>

                    <div className="col-lg-10 align-items-center">
                        <div className="ground">
                            <div className="row">
                    
                                <div className="col-lg-6 col-md-6">
                                    <ul className="sub-menu">
                                        <li><Link to="/admin/report-equipment-used-booking" className="active">
                                        Equipment Used Report 
                                        {/* <span style={{"margin-left":"30px","font-size":"14px"}}> {dateFormat(sideBarFilterDispatchedFromDate,"mmm dS")} to {dateFormat(sideBarFilterDispatchedToDate,"mmm dS")} 
                                        </span> */}
                                        
                                        </Link></li>

                                    </ul>
                                </div>

                                <div className="col-md-6 kit-filter text-right">
                                        <div className="custom_fltr">
                                            {/* <a onClick={()=>handleFilterToggle()}><FilterIcon className="img-svg"></FilterIcon></a> */}
                                            <FilterTooltip 
                                                handleFilterToggle={()=>handleFilterToggle()}
                                                filterModal={filterModal}
                                                filterPoChase={filterPoChaseRef.current}
                                                filterCreateDate={filterCreateDateRef.current}
                                                handleFilterRefreesh={(data)=>handleFilterRefreesh(data)}
                                                kits={kits}
                                                selectedKitProp={selectedKit}
                                                surgeons={surgeons}
                                                selectedSurgeonProp={selectedSurgeon}
                                                operationsList={operationsList}
                                                selectedOperationProp={selectedOperation}
                                            />
                                        </div>

                                        <button className={!loading && !isLoading ? 
                                            "btn btn-default add_print" :
                                            "btn btn-default add_print dropdown-disabled"
                                        } 
                                            onClick={() => !loading && !isLoading && bookingList?.length ? getXlsxData() : ""}
                                            id="ReportDownload"
                                        >
                                        <i className="fa fa-print" ></i>
                                        </button>

                                        {!loading && !isLoading ? "" : <UncontrolledTooltip
                                            target={"ReportDownload"}
                                        >
                                            {loading ? "Please wait" : isLoading ? "Please wait" : "No Record Found"}
                                        </UncontrolledTooltip>}
                                </div>

                            </div>
                            <div className="d-flex"><div className="small mr-3 badge badge-info" style={{fontWeight: "500", background: "#5d75e9"}}>{totalItemsCount} Records found</div></div>


                            <InfinitScroll
                                dataLength={bookingList.length}
                                next={()=>{bookingList.length > 5 ? getList(0) : ()=>{}; }}
                                hasMore={true}
                                scrollThreshold={"100%"}
                            >
                                <div id="table-scroll" className="table-scroll mt-4">
                                    <table id="main-table" className="main-table">
                                        <thead>
                                            <tr>
                                                <th scope="col" width="200">Hospital Name</th>
                                                {/* <th scope="col">Surgeon Name</th> */}
                                                <th scope="col">Item Used</th>
                                                <th scope="col">Manufacturers Code</th>
                                                {/* <th scope="col">Return Date</th> */}
                                                <th scope="col">Operation Name</th>
                                                {/* <th scope="col">Reps Name</th> */}
                                                <th scope="col">Feedback Note</th>
                                                <th scope="col">Outcome of the case</th> 
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bookingList && bookingList.map((item) => (


                                                <tr key={item._id}>
                                                    <td width="200" data-th="Hospital Name">
                                                        <div className="">
                                                            <Link to={"/admin/booking/details/" + item._id}>
                                                                <span><strong><span style={{ "display": "block" }} className="theme-text">{item.booking_id}</span>
                                                                    {item?.hospitalData[0]?.name}</strong></span><br />
                                                                    
                                                                    {item?.bookingSurgeonData
                                                                    ?.SurgeonDetail?.length >
                                                                        0 && (
                                                                        <React.Fragment>
                                                                            <span>
                                                                                <small>
                                                                                    Surgeon:
                                                                                </small>{" "}
                                                                                <strong>
                                                                                {item
                                                                                    .bookingSurgeonData
                                                                                    .SurgeonDetail[0]
                                                                                    .first_name +
                                                                                    " " +
                                                                                    item
                                                                                        .bookingSurgeonData
                                                                                        .SurgeonDetail[0]
                                                                                        .last_name}
                                                                                </strong>
                                                                            </span><br />
                                                                        </React.Fragment>
                                                                    )}
                                                                    <span>
                                                                        <small>Reps Name:</small>{" "}
                                                                        <strong>{item?.assignedRepsDetail?.[0]?.first_name} {item?.assignedRepsDetail?.[0]?.last_name}</strong>
                                                                    </span>
                                                                    
                                                               
                                                            </Link>
                                                        </div>
                                                    </td>
                                                    
                                                    {(() => {
                                                        let nameList = [];
                                                        let codeList = [];

                                                        (item?.itemUsedProducts || []).forEach((kset, ind) => {
                                                            nameList.push(
                                                            <li key={`name-${ind}`}>
                                                                <span className={`status circle mr-1 ${getStatusConfig(kset)}`}></span>
                                                                {kset?.productData?.name || "-"}
                                                            </li>
                                                            );

                                                            codeList.push(
                                                            <li key={`code-${ind}`}>
                                                                {kset?.productData?.manufacturers_product_code || "-"}
                                                            </li>
                                                            );
                                                        });

                                                        return (
                                                            <>
                                                            {/* Product Name */}
                                                            <td className="align-top">
                                                                <small>
                                                                <ul className="list">
                                                                    {nameList.length ? nameList : <li></li>}
                                                                </ul>
                                                                </small>
                                                            </td>

                                                            {/* Manufacturer Code */}
                                                            <td className="align-top">
                                                                <small>
                                                                <ul className="list">
                                                                    {codeList.length ? codeList : <li></li>}
                                                                </ul>
                                                                </small>
                                                            </td>
                                                            </>
                                                        );
                                                        })()}
                                                    {/* <td data-th="Sets" className="align-top">
                                                        <small>
                                                            
                                                        <ul className="list">
                                                            {item.itemUsedProducts && item.itemUsedProducts.map((kset, ind) => (
                                                                <React.Fragment key={ind}>
                                                                    <li>
                                                                    <span
                                                                        className={`status circle mr-1 ${getStatusConfig(kset)}`}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title=""
                                                                        data-original-title="Retuned"></span>
                                                                         <span >
                                                                            {kset.productData.name}( {kset.productData.manufacturers_product_code})
                                                                        </span>
                                                                    </li>
                                                                
                                                                </React.Fragment>
                                                            ))}
                                                        </ul>
                                                        </small>
                                                    </td> */}

                                                    <td data-th="Operation Name">
                                                        {item.operation_name ===
                                                            "Other" ? (
                                                            <span>
                                                                {" "}
                                                                {
                                                                    item.other_opration
                                                                }{" "}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {" "}
                                                                {
                                                                    item.operation_name
                                                                }{" "}
                                                            </span>
                                                        )}
                                                    </td>

                                                    <td data-th="Feedback Note">
                                                            <span>
                                                                {item?.bookingProductsReviews?.[0]?.description || ""}
                                                            </span>
                                                    </td>
                                                    <td data-th="Outcome of the case">
                                                            <span>
                                                                {item?.bookingProductsReviews?.[0]?.review || ""}
                                                            </span>
                                                    </td>

                                                    {/* <td data-th="Contact Person">
                                                        <div className="info-left">
                                                             <small>Dispatch prepare by: <strong>{item?.bookingLogs[0]?.bookingLogs_by_user[0]?.first_name} {item?.bookingLogs[0]?.bookingLogs_by_user[0]?.last_name} </strong></small><br />

                                                            <small>Dispatched by: <strong>{ item?.dispatchData[0]?.dispatched_by } </strong></small><br />
                                                            <small>Dispatch time taken:<strong>  {PrepareTimer(item)}</strong></small>
                                                        </div>
                                                    </td> */}
                                                </tr>
                                            ))}
                                            {bookingList && bookingList.length == 0 && loading == false &&
                                                <tr className="text-center">
                                                    <td colSpan="6">No Record Found</td>
                                                </tr>
                                            }

                                            {loading == true || bookingList && bookingList.length == 0 && loading == true ?
                                                ([1, 2, 3, 4, 5, 6,7].map((item) => (
                                                    <tr key={item}>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                            </p>
                                                        </td>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                            </p>
                                                        </td>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>

                                                            </p>
                                                        </td>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>

                                                            </p>
                                                        </td>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>

                                                            </p>
                                                        </td>
                                                        <td >
                                                            <p className="placeholder-glow">
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>
                                                                <div className="skeleton skeleton-text"></div>

                                                            </p>
                                                        </td>

                                                    </tr>
                                                ))) : ""
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </InfinitScroll>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Index;